<script>
import RealityUpgradeButton from "./RealityUpgradeButton";

export default {
  name: "RealityUpgradesTab",
  components: {
    RealityUpgradeButton
  },
  computed: {
    upgrades: () => RealityUpgrades.all,
    costScalingTooltip: () => `Цены начинают увеличиваться быстрее после ${format(1e30)} МР и ещё быстрее
      после ${format(Decimal.NUMBER_MAX_VALUE, 1)} МР`,
    possibleTooltip: () => `Клетчатые улучшение невозможно открыть в текущей Реальности. Улучшения в полоску
      всё ещё доступны.`,
    lockTooltip: () => `Это сработает только в случае, если вы ещё не провалили условие и не открытли улучшение.`,
  },
  methods: {
    id(row, column) {
      return (row - 1) * 5 + column - 1;
    }
  }
};
</script>

<template>
  <div class="l-reality-upgrade-grid">
    <div class="c-reality-upgrade-infotext">
      Наведите мышкой на <i class="fas fa-question-circle" /> значки для дополнительной информации.
      <br>
      Первый ряд улучшений может быть куплен бесконечное количество раз за постоянно повышающиеся цены
      <span :ach-tooltip="costScalingTooltip">
        <i class="fas fa-question-circle" />;
      </span>
      остальные улучшения одноразовые.
      <br>
      Одноразовые улучшения также имеют условия, которые, при единоразовом удовлетворении, навсегда открывают
      возможность купить улучшение в любой момент.
      <span :ach-tooltip="possibleTooltip">
        <i class="fas fa-question-circle" />
      </span>
      <br>
      Заблокированные улучшения по стандарту показывают их условие и эффект; разблокированные показывают их эффект,
      текущий бонус и цену. Зажмите шифт чтобы изменить это поведение.
      <br>
      Вы можете нажать на улучшение с зажатым шифтом <i class="fas fa-lock-open" /> чтобы приказать игре Зафиксировать
      условие данного улучшения. Игра попытается предотвратить любые действия в этой Реальности, которые могут привести
      к провалу условия Зафиксированного улучшения.
      <span :ach-tooltip="lockTooltip">
        <i class="fas fa-question-circle" />
      </span>
      <br>
      Каждый завершенный ряд купленных улучшений повышает уровень ваших Глифов на {{ formatInt(1) }}.
    </div>
    <div
      v-for="row in 5"
      :key="row"
      class="l-reality-upgrade-grid__row"
    >
      <RealityUpgradeButton
        v-for="column in 5"
        :key="id(row, column)"
        :upgrade="upgrades[id(row, column)]"
      />
    </div>
  </div>
</template>

<style scoped>
.c-reality-upgrade-infotext {
  color: var(--color-text);
  margin: -1rem 0 1.5rem;
}
</style>
